module.exports = __webpack_public_path__ + "static/zdjęcia14-237c86fa1f6f0197e384ea0c0462fdf0.svg";